<template>
  <div class="head_class flex-row">
    <div class="section_1 flex-col"></div>
    <span class="text_1" style="margin-top: 7px; margin-left: 10px;">人工智能工业赋能中心</span>
    <div class="text-wrapper_1">
      <div v-for="item in menuData"
           :key="item.id"
           :class="['menu-item', { active: currentActive === item.id }]"
            @click="handleMenuClick(item.id)"
           @mouseenter="handleMouseEnter(item)"
           @mouseleave="handleMouseLeave(item)"
      >
        <div>
          {{ item.title }}
        </div>
        <ul class="submenu"
            :class="{ 'submenu-active': item.isActive && item.children.length }"
            @mouseleave="handleSubmenuLeave(item)"
         >
          <li
              v-for="obj in item.children"
              :class="{'select-active': selectActive == obj.id, subMenuChildren: true}"
              :key="obj.id"
              @click.stop="handleSubmenuClick(obj.id,obj.parentId)"
          >
            {{obj.title}}
          </li>
<!--          <li class="select-active">数字化平台</li>-->
        </ul>
      </div>
    </div>
    <!--    <span class="text_4">登录</span>-->
    <div class="section_5 flex-col"></div>
    <div class="section_6 flex-col"></div>
    <div class="section_7 flex-col"></div>
    <div class="section_8 flex-col"></div>
    <div class="section_9 flex-col"></div>
    <div class="section_10 flex-col"></div>
  </div>
</template>

<script>
export default {
  name: 'HeadVue',
  data() {
    return {
      selectActive: "",
      hoverTimer: null,
      menuData: [
        {
          id: 1,
          title: '首页',
          isActive: false
        },
        {
          id: 2,
          title: '产品中心',
          isActive: false,
          children: [
            {
              parentId: 2,
              id: 21,
              title: 'AI平台',
            },
            {
              parentId: 2,
              id: 22,
              title: '数字化平台',
            },
          ]
        },
        {
          id: 3,
          title: '解决方案',
          isActive: false
        },
        {
          id: 4,
          title: '明晟研究院',
          isActive: false
        },
        // {
        //   id: 8,
        //   title: '创作引擎',
        //   isActive: false
        // },
        // {
        //   id: 9,
        //   title: '未来工坊',
        //   isActive: false
        // },
        {
          id: 7,
          title: '关于我们',
          isActive: false
        },

      ],
      menuItems: ['首页', '产品中心', '解决方案', '明晟研究院', '关于我们'],
      currentActive: 0
    }
  },
  created() {
    // 根据当前路由路径设置激活菜单
    this.setActiveMenu(this.$route.path);
  },
  watch: {
    // 监听路由变化
    '$route'(to) {
      this.setActiveMenu(to.path);
    }
  },
  methods: {
    handleSubmenuClick(id,parentId){
      this.currentActive = parentId;
      this.selectActive = id
      switch (id) {
        case 21:
          this.$router.push('/product');
          break;
        case 22:
          this.$router.push('/minsun_kunying');
          break;
      }
    },
    handleMouseEnter(item) {
      if (item.children) {
        clearTimeout(this.hoverTimer)
        item.isActive = true
      }
    },
    handleSubmenuLeave(item) {
      if (item.children) {
        clearTimeout(this.hoverTimer)
        item.isActive = false
      }
    },
    handleMouseLeave(item) {
      if (item.children) {
        this.hoverTimer = setTimeout(() => {
          item.isActive = false
        }, 150)
      }
    },
    handleMenuClick(index) {

      this.currentActive = index;
      // this.selectActive = 21
      // 根据菜单索引进行路由跳转
      switch (index) {
        case 1:
          this.$router.push('/home');
          break;
        case 2:
          this.$router.push('/product');
          break;
        case 3:
          this.$router.push('/scheme');
          break;
        case 4:
          this.$router.push('/minsun_academy');
          break;
        case 6:
          this.$router.push('/minsun_mubanzhongxin');
          break;
        case 7:
          this.$router.push('/about');
          break;
        case 8:
          window.open('http://60.172.131.22:5700/')
          break;
        case 9:
          window.open('https://minsun-ai.com/wlgf/')
          break;
      }
    },
    setActiveMenu(path) {
      // 根据路径设置激活菜单
      switch (path) {
        case '/home':
          this.currentActive = 1;
          break;
        // case '/minsun_chanpinzhongxin':
        //   this.currentActive = 2;
        //   break;
        case '/product':
          this.currentActive = 2;
          this.selectActive = 21
          break;
        case '/minsun_kunying':
          this.currentActive = 2;
          this.selectActive = 22
          break;
        case '/scheme':
          this.currentActive = 3;
          break;
        case '/minsun_academy':
          this.currentActive = 4;
          break;

        case '/minsun_mubanzhongxin':
          this.currentActive = 6;
          break;
        case '/about':
          this.currentActive = 7;
          break;
      }
    }
  }
}
</script>

<style scoped>
.subMenuChildren:hover{
  width: 148px;
  height: 28px;
  background: rgba(7,103,252,0.1);
  border-radius: 3px 3px 3px 3px;
  font-size: 14px;
  color: #0767FC !important;
  margin-left: 5px;
}
.submenu-active {
  position: relative;
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  width: 100%;
  display: block !important;
}
.submenu {
  position: absolute;
  background: #FFFFFF;
  top:57px;
  display: none;
  width: 160px;
  height: 70px;
  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.1), 0px 8px 10px 1px rgba(0,0,0,0.06), 0px 3px 14px 2px rgba(0,0,0,0.05);
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #DCDCDC;
  padding-top: 2px;
}
.submenu li {
  width: 148px;
  height: 28px;
  //padding-top: 10px;
  padding-left: 10px;
  margin-top: 2px;
  font-size: 14px;
  color: #1A1A1A;
  margin-left: 5px;
}
.select-active{
  width: 148px;
  height: 28px;
  background: rgba(7,103,252,0.1);
  border-radius: 3px 3px 3px 3px;
  font-size: 14px;
  color: #0767FC !important;
  margin-left: 5px;
}
.submenu-item {
  padding: 8px 25px;
}

.submenu-item a {
  color: #333;
  text-decoration: none;
  display: block;

}

.submenu-item:hover {
  background: #f5f5f5;
}

.submenu-item:hover a {
  color: #1890ff;
}
.head_class {
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  //overflow-x: auto;
}

.section_1 {
  height: 27px;
  background: url(./assets/img/logo.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 150px;
  //margin: 16px 0 0 377px;
}

.text_1 {
  width: 140px;
  height: 20px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: Helvetica, "Microsoft YaHei", Arial, sans-serif;
  font-weight: NaN;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  //margin: 23px 0 0 11px;
}

.text-wrapper_1 {
  //width: 600px;
  height: 30px;
  display: flex;
  /* 使用 flex 布局 */
  justify-content: space-between;
  /* 均匀分布菜单项 */
  align-items: center;
  font-size: 14px;
  font-family: Helvetica, "Microsoft YaHei", Arial, sans-serif;
  //margin: 15px 0 0 14vw;
  margin-left: 8%;

}

.menu-item {
  color: rgba(51, 51, 51, 1);
  padding: 14px 20px;
  /* 调整内边距 */
  cursor: pointer;
  white-space: nowrap;
  /* 防止文字换行 */
  transition: color 0.3s;
  position: relative;
  /* 添加颜色过渡效果 */
}

.menu-item.active {
  color: rgba(7, 103, 252, 1);
  font-weight: 500;
  /* 选中项加粗 */
}

.text_2 {
  width: 413px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(7, 103, 252, 1);
  font-size: 14px;
  font-family: Helvetica, "Microsoft YaHei", Arial, sans-serif;
  font-weight: NaN;
  text-align: left;
  line-height: 30px;
}

.text_3 {
  width: 413px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: Helvetica, "Microsoft YaHei", Arial, sans-serif;
  font-weight: NaN;
  text-align: left;
  line-height: 30px;
}

.text_4 {
  width: 28px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: Helvetica, "Microsoft YaHei", Arial, sans-serif;
  font-weight: NaN;
  text-align: left;
  line-height: 30px;
  margin: 15px 361px 0 129px;
}

.section_5 {
  position: absolute;
  left: 425px;
  top: 25px;
  width: 21px;
  height: 19px;
}

.section_6 {
  position: absolute;
  left: 445px;
  top: 25px;
  width: 18px;
  height: 19px;
}

.section_7 {
  position: absolute;
  left: 484px;
  top: 25px;
  width: 21px;
  height: 19px;
}

.section_8 {
  position: absolute;
  left: 401px;
  top: 18px;
  width: 16px;
  height: 27px;
}

.section_9 {
  position: absolute;
  left: 391px;
  top: 16px;
  width: 27px;
  height: 22px;
}

.section_10 {
  position: absolute;
  left: 377px;
  top: 16px;
  width: 170px;
  height: 28px;
}
</style>
